import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Place } from '@mui/icons-material';



const Marker = ({ text, onClick }) => (
    <Place fontSize='large' sx={{
        color: '#ff0000',
        "&:hover": {
            zIndex: 1
        },
        transform: 'translate(-50%, -50%)'
    }} />
);

Marker.defaultProps = {
    onClick: null,
};

Marker.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
};

export default Marker;